// Add this to your existing dateUtils.js

/**
 * For sidebar display: shows time if today, date otherwise
 */
export const formatSidebarTime = (date) => {
  if (!date) return "";

  const messageDate = new Date(date);
  if (isNaN(messageDate)) return "";

  const now = new Date();

  const isToday =
    messageDate.getDate() === now.getDate() &&
    messageDate.getMonth() === now.getMonth() &&
    messageDate.getFullYear() === now.getFullYear();

  const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    messageDate.getDate() === yesterday.getDate() &&
    messageDate.getMonth() === yesterday.getMonth() &&
    messageDate.getFullYear() === yesterday.getFullYear();

  const isSameYear =
    messageDate.getFullYear() === now.getFullYear();

  // If message is today → show time
  if (isToday) {
    return messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

    // Yesterday
  if (isYesterday) {
    return "Yesterday";
  }
  // If same year → show day + month
  if (isSameYear) {
    return messageDate.toLocaleDateString([], {
      day: "2-digit",
      month: "short",
    });
  }

  // If previous year → show day + month + year
  return messageDate.toLocaleDateString([], {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
/**
 * Converts a Twilio UTC date to the user's local timezone
 * Twilio returns Date objects or ISO strings — both are UTC
 */
export const toLocalDate = (twilioDate) => {
  if (!twilioDate) return null;
  // If it's already a Date object, JS automatically handles UTC → local
  // If it's a string, new Date() parses it as UTC
  return new Date(twilioDate);
};

export const formatMessageTime = (twilioDate) => {
  const date = toLocalDate(twilioDate);
  if (!date || isNaN(date)) return "";

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // change to false for 24hr
  });
};

export const formatMessageDate = (twilioDate) => {
  const date = toLocalDate(twilioDate);
  if (!date || isNaN(date)) return "";

  return date.toLocaleDateString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

export const isToday = (twilioDate) => {
  const date = toLocalDate(twilioDate);
  const now = new Date();
  return (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
};

export const isYesterday = (twilioDate) => {
  const date = toLocalDate(twilioDate);
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

export const isNewDay = (dateA, dateB) => {
  const a = toLocalDate(dateA);
  const b = toLocalDate(dateB);
  return (
    a.getDate() !== b.getDate() ||
    a.getMonth() !== b.getMonth() ||
    a.getFullYear() !== b.getFullYear()
  );
};